import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AdminTemplateComponent } from '@app/templates/admin-template/admin-template.component';
import { UserTemplateComponent } from './templates/user-template/user-template.component';
import { AuthComponent } from './components/auth/auth.component';
import { ForgotPasswordComponent } from "@app/components/forgot-password/forgot-password.component";
import { ForbiddenComponent } from '@app/components/error-pages/forbidden/forbidden.component';
import { NotFoundComponent } from '@app/components/error-pages/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeRedirectGuard } from './guards/home-redirect.guard';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [

  { path: '', pathMatch: 'full', canActivate: [HomeRedirectGuard], children: [] },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'auth', component: AuthComponent },
  { path: 'forgot-Password', component: ForgotPasswordComponent },
  { path: 'forbidden', component: ForbiddenComponent },
  { path: 'not-found', component: NotFoundComponent },
  {
    path: 'admin',
    component: AdminTemplateComponent,
    canActivate: [AdminGuard],
    canActivateChild: [AdminGuard],
    loadChildren: () => import('@app/components/admin/admin.module').then(m => m.AdminModule)
  },

{
  path: 'user',
  component: UserTemplateComponent,
  canActivate: [AuthGuard],
  // /user settings routes reuse components declared by AdminModule.
  loadChildren: () => import('@app/components/admin/admin.module')
    .then(() => import('@app/components/user/user.module'))
    .then(m => m.UserModule)
},
  { path: '**', component: NotFoundComponent  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
